import React from "react";
import "@/styles/component/loading.scss"

export const Loading: React.FC = () => {

  return (
    <div className={"loading"}>
      <div className={"circle"}></div>
    </div>
  );
};
